export default "__VITE_ASSET__DZD1W8RG__"